import { Emoji } from './emoji.js'

export * from './data.js'
export * from './emoji.js'
export * from './helpers/emojiToShortcode.js'
export * from './helpers/shortcodeToEmoji.js'

export default Emoji
